import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

import enUS from './locales/en-US.json';
import memberApi from '../libs/api/memberApi';
import zhCN from './locales/zh-CN.json';
import zhHK from './locales/zh-HK.json';

let i18nextLng = localStorage.getItem('i18nextLng') || 'zh-HK';
if (['tc','zh-HK', 'zh-TW', 'zh-MO'].includes(i18nextLng)) {
  memberApi.setLanguage('tc');
} else if (['sc', 'zh-CN', 'zh-SG', 'zh-MY'].includes(i18nextLng)) {
  memberApi.setLanguage('sc');
} else if (['en', 'en-US'].includes(i18nextLng)) {
  memberApi.setLanguage('en');
}

const resources = {
  'en-US': {
    translation: enUS
  },
  'zh-HK': {
    translation: zhHK
  },
  'zh-CN': {
    translation: zhCN
  }
};

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: i18nextLng,
    fallbackLng: i18nextLng,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;